import { render, staticRenderFns } from "./Setari_email.vue?vue&type=template&id=feb91718&scoped=true"
import script from "./Setari_email.vue?vue&type=script&lang=js"
export * from "./Setari_email.vue?vue&type=script&lang=js"
import style0 from "./Setari_email.vue?vue&type=style&index=0&id=feb91718&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "feb91718",
  null
  
)

export default component.exports